import { z } from "zod";
import { zUid, ZUid } from "src/types/zUid";
import { zAttrLabelMeta, ZAttrLabelMeta } from "./ZAttrLabelMeta";

export const zAttrLabelTreeData: z.ZodType<{
  key: string;
  attrId: ZUid;
  labels?: string[];
  attrLabelMeta?: ZAttrLabelMeta;
  children?: ZAttrLabelTreeData[];
}> = z.lazy(() =>
  z.object({
    key: z.string(),
    attrId: zUid,
    labels: z.string().array().optional(),
    attrLabelMeta: zAttrLabelMeta.optional(),
    children: zAttrLabelTreeData.array().optional(),
  }),
);

export type ZAttrLabelTreeData = z.infer<typeof zAttrLabelTreeData>;
